import { Component, OnInit, ViewEncapsulation, ViewChild, Output, EventEmitter } from '@angular/core';
import { RequestService } from 'src/app/services/request.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { ShareDataService } from 'src/app/services/share-data.service';
import { MatSelect } from '@angular/material/select';
import { FarmerhistoryComponent } from './farmerhistory/farmerhistory.component';
import { CrophistoryComponent } from './crophistory/crophistory.component';
import { TreatmentshistoryComponent } from '../history/treatmentshistory/treatmentshistory.component';
import { SeedhistoryComponent } from './seedhistory/seedhistory.component';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoryComponent implements OnInit {
  @ViewChild('select') select!: MatSelect;
  @ViewChild(FarmerhistoryComponent) farmer: any;
  @ViewChild(CrophistoryComponent) cropIrrigation: any;
  @ViewChild(CrophistoryComponent) cropFertil: any;
  @ViewChild(CrophistoryComponent) cropSpray: any;
  @ViewChild(CrophistoryComponent) cropHarvest: any;
  @ViewChild(TreatmentshistoryComponent) treatment: any;
  @ViewChild(SeedhistoryComponent) planting: any;
  @ViewChild(SeedhistoryComponent) seeding: any;

  @Output() selectedValuesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  plotCodes: any[] = [];
  selectedItems = new FormControl(<any[]>[]);
  plotChoose: any = [];
  codes: any[] = [];

  allSelected = false;
  setAllStatus = false;

  farmerId: any;
  afmFarmer: any;
  firstName: any;
  lastName: any;
  selectedYear: string = '';
  langStatus: any;

  plotValueCrop: any;
  plotTypeCrop: any;
  plotValueTreatments: any;
  plotTypeTreatments: any;
  plotValueSeed: any;
  plotTypePlantSeed: any;

  isIrrigation = false;
  isFertilisation = false;
  isSpraying = false;
  isHarvest = false;
  isTreatment = false;
  isSeeding = false;
  isPlanting = false;

  farmerSelectBoolean = false;
  cropSelectBoolean = false;
  manageSelectBoolean = false;
  seedSelectBoolean = false;

  parentCode: any;
  childCode: any;
  parentCodeBoolean = false;
  childCodeBoolean = false;
  parentBox = false;
  childBox = false;
  eventParent: any;
  eventChild: any;

  selectType: string[] = [];
  selectTypeTreatments: string[] = [];
  selectTypeSeed: string[] = [];

  startingDate: any;
  endingDate: any;
  startingDateString: string = '';
  endingDateString: string = '';

  tabStatus: any;

  constructor(
    private req: RequestService<any>,
    public translate: TranslateService,
    private shareDataService: ShareDataService
  ) { }

  ngOnInit() {
    this.allSelected = false
    this.shareDataService.getData<any>('farmer').subscribe((data) => {
      if (data) {
        this.selectedYear = data.selected_year_data;
        this.startingDate = `${this.selectedYear}-01-01`;
        this.endingDate = `${this.selectedYear}-12-31`;
        this.startingDateString = this.startingDate;
        this.endingDateString = this.endingDate;
      }
    });

    this.farmerSelectBoolean = true;
    this.getCodes();
    this.getFarmer();

    const isEnglish = this.langStatus === 'en';
    this.selectType = isEnglish ? ['Irrigation', 'Fertilisation', 'Spraying', 'Harvest'] : ['Άρδευση', 'Λίπανση', 'Φυτοπροστασία', 'Συγκομιδή'];
    this.selectTypeTreatments = isEnglish ? ['Treatment'] : ['Εργασίες'];
    this.selectTypeSeed = isEnglish ? ['Seeding', 'Planting'] : ['Σπορά', 'Φύτευση'];
    this.plotTypeCrop = isEnglish ? 'Irrigation' : 'Άρδευση';
    this.plotTypeTreatments = isEnglish ? 'Treatment' : 'Εργασίες';
    this.plotTypePlantSeed = isEnglish ? 'Planting' : 'Φύτευση';
    this.plotChoose = this.codes;
  }

  getFarmer() {
    this.shareDataService.getData<any>('farmer').subscribe((res) => {
      if (res) {
        this.afmFarmer = res.vat_number;
        this.firstName = res.first_name;
        this.lastName = res.last_name;
      }
    });
  }

  getCodes() {
    this.shareDataService.getData<any>('plots').subscribe((res) => {
      if (res) {
        res.forEach((element: any) => {
          this.plotCodes.push([
            element.plot_code,
            element.size,
            element.crop_info[0]?.prod_tree_number,
            element.location,
            element.crop_info,
            element.crop_info?.variety,
            element.crop_info_id
          ]);
        });
      }
    });
  }

  applyDate() {
    this.startingDateString = this.getDateString(this.startingDate);
    this.endingDateString = this.getDateString(this.endingDate);
  }

  private getDateString(date: Date): string {
    const year = date.getFullYear();
    const month = this.formatNumber(date.getMonth() + 1);
    const day = this.formatNumber(date.getDate());
    return `${year}-${month}-${day}`;
  }

  private formatNumber(value: number): string {
    return value < 10 ? '0' + value : '' + value;
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    this.setAllStatus = this.allSelected
    this.plotChoose = this.allSelected
      ? [...this.plotCodes.flatMap((code: any) => code[4]), 'ALL']
      : [];
  }

  onSelectionChange(selected: any[]) {
    console.log(selected)
    this.allSelected = selected.includes('ALL');
    this.plotCodes.forEach((code: any) => {
      code[4].forEach((subtask: any) => {
        const isChecked = selected.includes(subtask);
      });
    });
  }

  updateAllComplete(selected : Event) {
    console.log(selected)
    console.log(this.plotChoose)
    this.allSelected = this.plotCodes.every((code: any) =>
      code[4].every((task: any) => this.plotChoose.includes(task))
    );
  }

  // Τα data calls
  irrigationData() { this.cropIrrigation.getIrrigationData(); }
  fertData() { this.cropFertil.getFertilisationData(); }
  sprayData() { this.cropSpray.getSprayingData(); }
  harvestData() { this.cropHarvest.getHarvestData(); }
  plantData() { this.planting.getPlantingData(); }
  seedData() { this.seeding.getSeedingData(); }
  // Τα exports
  exportCsvHisory() { this.farmer.exportCsv(); }
  exportExcelFarmer() { this.farmer.exportExcel(); }
  exportPdfFarmer() { this.farmer.exportPdf(); }
  exportCsvCropIrrigation() { this.cropIrrigation.exportCsvIrrigation(); }
  exportExcelCropIrrigation() { this.cropIrrigation.exportExcelIrrigation(); }
  exportPdfCropIrrigation() { this.cropIrrigation.exportPdfIrrigation(); }
  exportCsvFertil() { this.cropFertil.exportCsvFertil(); }
  exportExcelFertil() { this.cropFertil.exportExcelFertil(); }
  exportPdfFertil() { this.cropFertil.exportPdfFertil(); }
  exportCsvSpraying() { this.cropSpray.exportCsvSpraying(); }
  exportExcelSpray() { this.cropSpray.exportExcelSpray(); }
  exportPdfSpray() { this.cropSpray.exportPdfSpray(); }
  exportCsvHarvest() { this.cropHarvest.exportCsvHarvest(); }
  exportExcelHarvest() { this.cropHarvest.exportExcelHarvest(); }
  exportPdfHarvest() { this.cropHarvest.exportPdfHarvest(); }
  exportCsvTreatment() { this.treatment.exportCsvTreatment(); }
  exportExcelTreatment() { this.treatment.exportExcelTreatment(); }
  exportPdfTreatment() { this.treatment.exportPdfTreatment(); }
  exportCsvPlanting() { this.planting.exportCsvPlanting(); }
  exportExcelPlanting() { this.planting.exportExcelPlanting(); }
  exportPdfPlanting() { this.planting.exportPdfPlanting(); }
  exportCsvSeeding() { this.seeding.exportCsvSeeding(); }
  exportExcelSeeding() { this.seeding.exportExcelSeeding(); }
  exportPdfSeeding() { this.seeding.exportPdfSeeding(); }

  onTabChange(event: any): void {
    this.tabStatus = event.index;
    this.farmerSelectBoolean = this.tabStatus === 0;
    this.cropSelectBoolean = this.tabStatus === 1;
    this.manageSelectBoolean = this.tabStatus === 2;
    this.seedSelectBoolean = this.tabStatus === 3;
    const cropType = this.plotTypeCrop;
    const plantType = this.plotTypePlantSeed;
    if (this.tabStatus === 1) {
      this.isIrrigation = cropType === 'Irrigation' || cropType === 'Άρδευση';
      this.isFertilisation = cropType === 'Fertilisation' || cropType === 'Λίπανση';
      this.isSpraying = cropType === 'Spraying' || cropType === 'Φυτοπροστασία';
      this.isHarvest = cropType === 'Harvest' || cropType === 'Συγκομιδή';
      if (this.isIrrigation) this.irrigationData();
      if (this.isFertilisation) this.fertData();
      if (this.isSpraying) this.sprayData();
      if (this.isHarvest) this.harvestData();
    }
    if (this.tabStatus === 3) {
      this.isPlanting = plantType === 'Planting' || plantType === 'Φύτευση';
      this.isSeeding = plantType === 'Seeding' || plantType === 'Σπορά';

      if (this.isPlanting) this.plantData();
      if (this.isSeeding) this.seedData();
    }
  }
}
